import React from 'react'
import classnames from 'classnames'
import { withStyles } from '@material-ui/core/styles'
import { localize } from '../../util/Localizer'
import { Colors } from '../../theme'

class ProgressBar extends React.Component {
  render () {
    const { classes = {} } = this.props
    const completed = this.props.progress

    return (
      <div>
        <h4 className={classnames('sectionHeading', classes.progressBarTitle)}>
          {localize('common.header.submitClaim')} {completed}% {localize('pages.SubmitAClaim.ProgressBar.complete')}
        </h4>
        <div className={classes.progressBarContainer}>
          <div className={classes.progressBar} style={{ width: `${completed}%` }} />
        </div>
      </div>
    )
  }
}

const Styles = {
  progressBarTitle: {
    marginBottom: 5
  },
  progressBarContainer: {
    border: `1px solid ${Colors.Palette.borderColor}`
  },
  progressBar: {
    backgroundColor: Colors.Palette.primaryColor,
    transition: 'width 0.5s',
    height: 12
  }
}

export default withStyles(Styles)(ProgressBar)



// WEBPACK FOOTER //
// ./src/widgets/SubmitAClaim/ProgressBar.js